import { ctaTranslate } from "../lib/ctaTranslate";
import type { CouponInputData } from "../types";
import { FormShell } from "./_form";

interface Props {
  data: CouponInputData;
  sessionToken: string;
}

export default function CouponInputCard({ data, sessionToken }: Props) {
  return (
    <FormShell
      title={data.title}
      subtitle={data.subtitle}
      fields={data.fields}
      submitLabel={data.submitLabel}
      onSubmit={(values) => {
        const code = (values.code || "").trim().toUpperCase();
        void ctaTranslate({
          code: "coupon_input.apply_coupon_prompt",
          params: { code },
          sessionToken,
          fallback: `Apply coupon ${code}`,
          toolCall: {
            tool: "commerce_apply_coupon",
            args: { coupons: [{ code }] },
          },
        });
      }}
    />
  );
}
